














import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import CzMenu from "../menu/czmenu.vue";
import Footer from "@/shared/components/footer/footer.vue";
import store from "@/shared/core/store";
import { applyBrandTheme } from "@/shared/core/helpers/brandHelper";
import { hideFooterFor } from "@/shared/core/whatsappPay";

@Component({
  components: {
    CzMenu,
    Footer,
  },
})
export default class InSecure extends Vue {
  get showFooter() {
    return !hideFooterFor(this.$route.name);
  }

  mounted() {
    applyBrandTheme(store.state.settings);
  }
}
